/**
 * «Помощь» в «Настройках»: «Как пользоваться» и «Частые вопросы» (22.10.2026,
 * docs/design/support-2026-10-22). Список — строками, как в «Настройках»; ответ —
 * шагом в том же листе, текстом как «О расчётах и ограничениях» и со снимком.
 */
import { useState } from 'react';
import { Icon } from './icon.js';
import { SheetWrap } from './sheet.js';
import { FAQ, GUIDES, type HelpItem } from './help-content.js';

const CH = () => <span className="ch"><Icon name="chevron-right" size={13} /></span>;

export function HelpSheet({ kind, onClose }: { kind: 'guides' | 'faq'; onClose: () => void }) {
  const [open, setOpen] = useState<HelpItem | null>(null);
  const title = kind === 'guides' ? 'Как пользоваться' : 'Частые вопросы';
  const row = (it: HelpItem) => (
    <button key={it.id} className="li w" onClick={() => setOpen(it)}>
      <div className="nm"><b>{it.title}</b></div><CH />
    </button>
  );
  return (
    <SheetWrap title={open ? open.title : title} onClose={onClose}
      {...(open ? { onBack: () => setOpen(null), backLabel: `Назад: ${title}` } : {})}>
      {open ? (
        <div className="chat-about help-answer">
          {open.text.map((p) => <p key={p}>{p}</p>)}
          {open.shot && <img className="help-shot" src={`/help/${open.shot}.jpg`} alt="" loading="lazy" />}
        </div>
      ) : kind === 'guides' ? (
        <div className="fieldlist">{GUIDES.map(row)}</div>
      ) : (
        <div className="fieldlist">
          {FAQ.map((g) => (
            <div key={g.title}>
              <div className="ops-group grp"><span>{g.title}</span></div>
              {g.items.map(row)}
            </div>
          ))}
        </div>
      )}
    </SheetWrap>
  );
}
